import { render, staticRenderFns } from "./ParagraphList.vue?vue&type=template&id=0c23229a&scoped=true"
import script from "./ParagraphList.vue?vue&type=script&lang=js"
export * from "./ParagraphList.vue?vue&type=script&lang=js"
import style0 from "./ParagraphList.vue?vue&type=style&index=0&id=0c23229a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c23229a",
  null
  
)

export default component.exports